import { useEffect, useState } from "react";
import HtmlWithScripts from "@/components/common/HtmlWithScripts";
import BaseModule from "@/components/site-builder/BaseModule";
import type { HtmlBlockModuleType } from "./types";

export interface HtmlBlockModuleProps {
  module: HtmlBlockModuleType;
}

export default function HtmlBlockModule(props: HtmlBlockModuleProps) {
  const { module } = props;
  const {
    body: { html },
  } = module;

  const [htmlString, setHtmlString] = useState("");

  useEffect(() => {
    setHtmlString(html);
  }, [html]);

  return (
    <BaseModule module={module}>
      {htmlString && <HtmlWithScripts html={htmlString} />}
    </BaseModule>
  );
}
